/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export type RangeFilterLayout = 'inline' | 'stacked'

export const RANGE_FILTER_INPUT_BASE_CLASS =
    'flex-1 inline-flex items-center text-xs placeholder:text-xxs font-medium transition duration-150 bg-transparent placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:outline-0 focus:border-0 border-0 min-w-0'
